import axios from "../axios";

// 首页
const index = id => {
  return axios.get("items/" + id);
};

// 活动列表页

const analytics = (page, type) => {
  return axios.get("analytics?page=" + page + "&type=" + type);
};

// 活动详情

const analyticsDetail = id => {
  return axios.get("analytics/" + id);
};

// 点赞列表
const logsList = (id, page) => {
  return axios.get("items/" + id + "/logs?page=" + page);
};

// 打赏列表
const rewardsList = (id, page) => {
  return axios.get("items/" + id + "/rewards?page=" + page);
};

// 评价列表
const commentsList = (id, page) => {
  return axios.get("items/" + id + "/comments?page=" + page);
};

// 点赞接口
const logsAct = (url, captcha, key) => {
  return axios.post(url, {
    key: key,
    captcha: captcha
  });
};

// 点赞验证码 评论
const captcha = () => {
  return axios.get("captcha");
};

// 排行榜
const tops = voteId => {
  return axios.get("tops/" + voteId);
};

// 打赏钱列表
const create = id => {
  return axios.get("items/" + id + "/rewards/create");
};

//创建打赏
const createRewards = (id, giftId, total) => {
  return axios.post("items/" + id + "/rewards/" + giftId, {
    total: total
  });
};

// 评价接口
const creatComments = (url, content, captcha, key) => {
  return axios.post(url, {
    content: content,
    key: key,
    captcha: captcha
  });
};

// 获取分享链接
const share = id => {
  return axios.get("items/" + id + "/share");
};

const rewardsGlabel = 0;
const logsGlabel = 0;
const commentsGlabel = 0;
const pollsGlabel = 0;

export default {
  index,
  share,
  logsList, //点赞
  commentsList, //评价
  rewardsList, //打赏
  logsAct, //点赞接口
  tops, // 排行榜
  create, //打赏钱列表
  createRewards, //创建打赏
  creatComments, //创建评价
  rewardsGlabel,
  logsGlabel,
  commentsGlabel,
  pollsGlabel,
  captcha,
  analytics,
  analyticsDetail
};



// WEBPACK FOOTER //
// ./src/api/interfaces/index.js